import { SequenceStep, enumActions } from "../Guide";
import GuideUtils from "../GuideUtils";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addRoom from "./guideSequence_addRoom";
import openRoomOrFloorSequence from "./multibleSequencesHelp";

// ContextMenuLables.addFloors

function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let drawingAreaId = GuideUtils.openFloorDrawingAreaId();
  let floor = GuideUtils.openFloor() || state.floors.asArray().filter((floor) => floor.rooms.size > 1)[0];
  let firstRoom = floor?.rooms.asArray().filter((room) => !room.isFloorGeneralRoom && !room.isVisibleInFloorPlan)[0];
  let dragImage = "/images/codepen.png"; // no itx

  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (!firstRoom) {
          return [...guideSequence_addRoom("")];
        }
        return [];
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        floor = GuideUtils.openFloor() || state.floors.asArray().filter((floor) => floor.rooms.size > 1)[0];
        firstRoom = floor?.rooms.asArray().filter((room) => !room.isFloorGeneralRoom && !room.isVisibleInFloorPlan)[0];
        return [...openRoomOrFloorSequence({ roomGiven: floor })];
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        if (drawingAreaId == undefined) {
          drawingAreaId = GuideUtils.openFloorDrawingAreaId();
        }
        return [
          {
            id: ["toolbar", firstRoom.id],
            dragImage: dragImage,
            action: enumActions.drag,
          },
          { action: enumActions.wait },

          {
            action: enumActions.mousemove,
            id: drawingAreaId,

            positions: [
              [10, 10],
              [50, 50],
            ], // in % des Target Elements
          },

          {
            action: enumActions.drop,
            id: drawingAreaId,

            positions: [[50, 50]], // in % des Target Elements
            cursorType: "pointer",
          },

          {
            action: enumActions.wait,
          },
        ];
      },
    },
  ];
}

export default sequence;
